import React, { useState } from "react";

type ToggleOptions<T> = {
  label: string | React.ReactNode;
  value: T;
};

type ToggleButtonProps<T> = {
  options: ToggleOptions<T>[];
  className: string;
  selectedColor: string;
  handleToggle: (value: T) => void;
  defaultSelectedOption: ToggleOptions<T>;
  selectedTextColor: string;
  textColor: string;
};

const ToggleButton = <T,>({
  options,
  className,
  selectedColor,
  selectedTextColor,
  handleToggle,
  textColor,
  defaultSelectedOption,
}: ToggleButtonProps<T>) => {
  // TODO: Change the name as ambiguity with graphy/ui
  const [selectedValue, setSelectedValue] = useState<T>(
    defaultSelectedOption.value
  );

  const optionBgTextColor = (value: T) => {
    if (value == selectedValue)
      return `bg-${selectedColor} text-${selectedTextColor}`;
    else return `text-${textColor}`;
  };

  return (
    <div
      className={` ${className} flex cursor-pointer flex-row rounded-full border-2 border-grey-2 bg-[#E9E9F2]`}
    >
      {options.map((option: ToggleOptions<T>) => (
        <React.Fragment key={option.value as string}>
          <div
            className={`${optionBgTextColor(
              option.value
            )} rounded-full px-6 py-1`}
            onClick={() => {
              setSelectedValue(option.value);
              handleToggle(option.value);
            }}
          >
            {option.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ToggleButton;
